export const poets = [
  {
    id: 1,
    name: 'Johann Wolfgang von Goethe',
    years: '1749-1832',
    nationality: 'Deutsch',
    image: 'https://public.readdy.ai/ai/img_res/7a36ef7384a8568e7f160a9aa37b111d.jpg',
    quote: {
      de: 'Wer sich den Gesetzen nicht fügen will, muss die Gegend verlassen, wo sie gelten.',
      ru: 'Кто не хочет подчиняться законам, должен покинуть место, где они действуют.'
    },
    poem: {
      de: 'Über allen Gipfeln ist Ruh, in allen Wipfeln spürest du kaum einen Hauch.',
      ru: 'Над всеми вершинами покой, во всех верхушках ты едва чувствуешь дыхание.'
    }
  },
  {
    id: 2,
    name: 'Friedrich Schiller',
    years: '1759-1805',
    nationality: 'Deutsch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Friedrich%20Schiller%2C%20German%20poet%20and%20dramatist%20from%2018th%20century%2C%20noble%20elegant%20clothing%2C%20passionate%20intellectual%20expression%2C%20dramatic%20lighting%2C%20artistic%20romantic%20style%2C%20simple%20elegant%20background%20with%20manuscripts&width=400&height=500&seq=poet-schiller-portrait&orientation=portrait',
    quote: {
      de: 'Der Mensch ist nur da ganz Mensch, wo er spielt.',
      ru: 'Человек является полностью человеком только тогда, когда он играет.'
    },
    poem: {
      de: 'Freude, schöner Götterfunken, Tochter aus Elysium.',
      ru: 'Радость, прекрасная искра богов, дочь из Элизиума.'
    }
  },
  {
    id: 3,
    name: 'Heinrich Heine',
    years: '1797-1856',
    nationality: 'Deutsch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Heinrich%20Heine%2C%20German%20romantic%20poet%20from%2019th%20century%2C%20refined%20elegant%20attire%2C%20melancholic%20thoughtful%20expression%2C%20soft%20lighting%2C%20artistic%20romantic%20style%2C%20simple%20elegant%20background%20with%20writing%20desk&width=400&height=500&seq=poet-heine-portrait&orientation=portrait',
    quote: {
      de: 'Dort wo man Bücher verbrennt, verbrennt man am Ende auch Menschen.',
      ru: 'Там, где сжигают книги, в конце концов сжигают и людей.'
    },
    poem: {
      de: 'Du bist wie eine Blume, so hold und schön und rein.',
      ru: 'Ты как цветок, такая милая, прекрасная и чистая.'
    }
  },
  {
    id: 4,
    name: 'Alexander Puschkin',
    years: '1799-1837',
    nationality: 'Russisch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Alexander%20Pushkin%2C%20Russian%20romantic%20poet%20from%2019th%20century%2C%20elegant%20noble%20Russian%20attire%2C%20passionate%20creative%20expression%2C%20warm%20dramatic%20lighting%2C%20artistic%20romantic%20style%2C%20simple%20elegant%20background%20with%20Russian%20motifs&width=400&height=500&seq=poet-pushkin-portrait&orientation=portrait',
    quote: {
      de: 'Ich liebte dich, und diese Liebe noch, vielleicht, ist nicht erloschen in der Seele.',
      ru: 'Я вас любил: любовь еще, быть может, в душе моей угасла не совсем.'
    },
    poem: {
      de: 'Mein Freund, dem Vaterland weihn wir die schönen Regungen der Seele!',
      ru: 'Товарищ, верь: взойдет она, звезда пленительного счастья!'
    }
  },
  {
    id: 5,
    name: 'Anna Achmatowa',
    years: '1889-1966',
    nationality: 'Russisch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Anna%20Akhmatova%2C%20Russian%20poetess%20from%2020th%20century%2C%20elegant%20refined%20dress%2C%20strong%20dignified%20expression%2C%20soft%20dramatic%20lighting%2C%20artistic%20style%2C%20simple%20elegant%20background%20with%20Russian%20cultural%20elements&width=400&height=500&seq=poet-akhmatova-portrait&orientation=portrait',
    quote: {
      de: 'Ich lehre die Frauen zu sprechen, aber weiß nicht, wie man sie zum Schweigen bringt.',
      ru: 'Я научила женщин говорить, но не знаю, как заставить их замолчать.'
    },
    poem: {
      de: 'Alles ist geplündert, verraten, verkauft, der schwarze Tod hat seine Flügel ausgebreitet.',
      ru: 'Все расхищено, предано, продано, черной смерти мелькало крыло.'
    }
  },
  {
    id: 6,
    name: 'Rainer Maria Rilke',
    years: '1875-1926',
    nationality: 'Deutsch-Böhmisch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Rainer%20Maria%20Rilke%2C%20German-Bohemian%20poet%20from%20early%2020th%20century%2C%20refined%20intellectual%20attire%2C%20contemplative%20mystical%20expression%2C%20soft%20artistic%20lighting%2C%20romantic%20style%2C%20simple%20elegant%20background%20with%20books&width=400&height=500&seq=poet-rilke-portrait&orientation=portrait',
    quote: {
      de: 'Vielleicht sind wir hier, um zu sagen: Haus, Brücke, Brunnen, Tor, Krug, Obstbaum, Fenster.',
      ru: 'Возможно, мы здесь, чтобы сказать: дом, мост, колодец, ворота, кувшин, фруктовое дерево, окно.'
    },
    poem: {
      de: 'Wer jetzt kein Haus hat, baut sich keines mehr. Wer jetzt allein ist, wird es lange bleiben.',
      ru: 'Кто сейчас без дома, тот больше не построит. Кто сейчас один, тот долго останется один.'
    }
  },
  {
    id: 7,
    name: 'Joseph von Eichendorff',
    years: '1788-1857',
    nationality: 'Deutsch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Joseph%20von%20Eichendorff%2C%20German%20romantic%20poet%20from%2019th%20century%2C%20noble%20elegant%20clothing%2C%20dreamy%20romantic%20expression%2C%20warm%20soft%20lighting%2C%20artistic%20romantic%20style%2C%20simple%20elegant%20background%20with%20forest%20landscape&width=400&height=500&seq=poet-eichendorff-portrait&orientation=portrait',
    quote: {
      de: 'Schläft ein Lied in allen Dingen, die da träumen fort und fort.',
      ru: 'Спит песня во всех вещах, которые мечтают снова и снова.'
    },
    poem: {
      de: 'Wem Gott will rechte Gunst erweisen, den schickt er in die weite Welt.',
      ru: 'Кому Бог хочет оказать истинную милость, того он посылает в широкий мир.'
    }
  },
  {
    id: 8,
    name: 'Marina Zwetajewa',
    years: '1892-1941',
    nationality: 'Russisch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Marina%20Tsvetaeva%2C%20Russian%20poetess%20from%2020th%20century%2C%20elegant%20refined%20dress%2C%20intense%20passionate%20expression%2C%20dramatic%20lighting%2C%20artistic%20style%2C%20simple%20elegant%20background%20with%20Russian%20cultural%20motifs&width=400&height=500&seq=poet-tsvetaeva-portrait&orientation=portrait',
    quote: {
      de: 'Ich möchte mit dir leben in einer kleinen Stadt mit ewigen Glocken.',
      ru: 'Я хотела бы жить с тобой в маленьком городе с вечными колоколами.'
    },
    poem: {
      de: 'Alle Dichter sind Juden, alle Dichter sind Fremdlinge.',
      ru: 'Все поэты жиды, все поэты чужие.'
    }
  },
  {
    id: 9,
    name: 'Fjodor Tjutschew',
    years: '1803-1873',
    nationality: 'Russisch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Fyodor%20Tyutchev%2C%20Russian%20romantic%20poet%20from%2019th%20century%2C%20elegant%20noble%20Russian%20attire%2C%20wise%20philosophical%20expression%2C%20warm%20lighting%2C%20artistic%20romantic%20style%2C%20simple%20elegant%20background%20with%20nature%20elements&width=400&height=500&seq=poet-tyutchev-portrait&orientation=portrait',
    quote: {
      de: 'Russland kann man mit dem Verstand nicht begreifen.',
      ru: 'Умом Россию не понять.'
    },
    poem: {
      de: 'Sei still, verbirg dich und verhehle deine Gefühle und Träume.',
      ru: 'Молчи, скрывайся и таи и чувства и мечты свои.'
    }
  },
  {
    id: 10,
    name: 'Novalis',
    years: '1772-1801',
    nationality: 'Deutsch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Novalis%2C%20German%20romantic%20poet%20from%20late%2018th%20century%2C%20refined%20noble%20attire%2C%20mystical%20dreamy%20expression%2C%20soft%20ethereal%20lighting%2C%20artistic%20romantic%20style%2C%20simple%20elegant%20background%20with%20blue%20flower%20motif&width=400&height=500&seq=poet-novalis-portrait&orientation=portrait',
    quote: {
      de: 'Nach innen geht der geheimnisvolle Weg.',
      ru: 'Внутрь ведет таинственный путь.'
    },
    poem: {
      de: 'Wenn nicht mehr Zahlen und Figuren sind Schlüssel aller Kreaturen.',
      ru: 'Когда больше не числа и фигуры являются ключами всех созданий.'
    }
  },
  {
    id: 11,
    name: 'Eduard Mörike',
    years: '1804-1875',
    nationality: 'Deutsch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Eduard%20M%C3%B6rike%2C%20German%20romantic%20poet%20from%2019th%20century%2C%20modest%20elegant%20clothing%2C%20gentle%20contemplative%20expression%2C%20soft%20natural%20lighting%2C%20artistic%20romantic%20style%2C%20simple%20elegant%20background%20with%20pastoral%20elements&width=400&height=500&seq=poet-morike-portrait&orientation=portrait',
    quote: {
      de: 'Frühling lässt sein blaues Band wieder flattern durch die Lüfte.',
      ru: 'Весна снова развевает свою голубую ленту в воздухе.'
    },
    poem: {
      de: 'Er ists! Der Frühling hat sein blaues Band wieder flattern durch die Lüfte.',
      ru: 'Это он! Весна снова развевает свою голубую ленту в воздухе.'
    }
  },
  {
    id: 12,
    name: 'Sergei Jessenin',
    years: '1895-1925',
    nationality: 'Russisch',
    image: 'https://readdy.ai/api/search-image?query=Classical%20portrait%20painting%20of%20Sergei%20Yesenin%2C%20Russian%20lyric%20poet%20from%20early%2020th%20century%2C%20simple%20peasant-inspired%20elegant%20attire%2C%20melancholic%20romantic%20expression%2C%20soft%20golden%20lighting%2C%20artistic%20style%2C%20simple%20elegant%20background%20with%20birch%20trees&width=400&height=500&seq=poet-yesenin-portrait&orientation=portrait',
    quote: {
      de: 'Ich bereue nichts, ich rufe nichts zurück, ich weine nicht.',
      ru: 'Не жалею, не зову, не плачу.'
    },
    poem: {
      de: 'Du bist mir nicht mehr lieb, mein Herz ist kalt geworden.',
      ru: 'Ты мне больше не мила, остыло сердце мое.'
    }
  }
];
